import { COMPLETE_CLIENT_PANEL } from 'components/companies/CompleteClientPanel';
import ConfirmDialog from 'components/record/ConfirmDialog';
import useSlideOver from 'components/SlideOver/useSlideOver';
import UseContext from 'hooks/useContext';

/**
 * « Créer une mission » on a prospect (JBWEB-1456): the api refuses it a
 * mission, so its profile is completed first. Opened by
 * `askCompleteClientForMission({ companyId, companyName, idLocation })` from
 * the context; rendered once, in App, so that the company's page and the
 * mission form both call it. « Compléter la fiche client » opens with the
 * intent of a mission after it, which its panel follows on success only.
 */
const CompleteClientForMissionDialog = () => {
  const {
    language,
    missionClientPrompt,
    setMissionClientPrompt,
    setMissionAfterClient,
    setObjID,
  } = UseContext();
  const { toggleSlideOver } = useSlideOver();
  const text = (key) =>
    language.getValue(`completeClient.forMission.${key}`, '');

  const cancel = () => setMissionClientPrompt(null);
  const completeProfile = () => {
    const company = missionClientPrompt;
    setMissionClientPrompt(null);
    setMissionAfterClient(company);
    setObjID(company.companyId);
    toggleSlideOver(COMPLETE_CLIENT_PANEL);
  };

  return (
    <ConfirmDialog
      open={Boolean(missionClientPrompt)}
      title={text('title')}
      description={text('description')}
      cancelLabel={text('cancel')}
      confirmLabel={text('confirm')}
      onCancel={cancel}
      onConfirm={completeProfile}
    />
  );
};

export default CompleteClientForMissionDialog;
